module.exports = __webpack_public_path__ + "media/images/application/template/30-second-quote/used-c9efe3b1513929449d0f6a13e79ecfa8.png";